import { FormControlLabel, Radio, RadioGroup, Stack, Typography } from '@mui/material';
import { VisibilityTypes } from '@src/api';
import { border, buildDataTestIdAttribute, buildFullDataTestId, DATA_TEST_ID_SELECTION } from '@src/utils';
import { InputHTMLAttributes } from 'react';
import { Controller } from 'react-hook-form';

export const VisibilityProvider = ({ control }) => {
  const dataTestId = buildFullDataTestId(DATA_TEST_ID_SELECTION, 'visibility');
  return (
    <Stack padding="36px" gap="24px" borderBottom={border}>
      <Typography color="grey.700" variant="head24Medium" lineHeight="34px">
        Sharing settings
      </Typography>
      <Controller
        name="visibilityType"
        control={control}
        render={({ field: { value, onChange } }) => {
          const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
            onChange((event.target as HTMLInputElement).value);
          };
          return (
            <RadioGroup
              value={value}
              onChange={handleChange}
              sx={{ flexDirection: 'row', rowGap: '24px', alignItems: 'center' }}
            >
              <Typography
                variant="label14Bold"
                lineHeight="18px"
                color="#4B5563"
                component="p"
                width="120px"
                padding="12px 0"
              >
                Selection for
              </Typography>
              <Stack direction="row" gap="24px">
                <FormControlLabel
                  value={VisibilityTypes.ForMe}
                  sx={{ gap: '12px' }}
                  control={
                    <Radio
                      size="small"
                      inputProps={
                        {
                          ...buildDataTestIdAttribute(dataTestId, 'radio-input-for-me'),
                        } as InputHTMLAttributes<HTMLInputElement>
                      }
                    />
                  }
                  label={
                    <Typography color="grey.700" variant="label14Medium" lineHeight="">
                      Me
                    </Typography>
                  }
                />
                <FormControlLabel
                  value={VisibilityTypes.ForAll}
                  control={
                    <Radio
                      size="small"
                      inputProps={
                        {
                          ...buildDataTestIdAttribute(dataTestId, 'radio-input-for-all'),
                        } as InputHTMLAttributes<HTMLInputElement>
                      }
                    />
                  }
                  sx={{ gap: '12px' }}
                  label={
                    <Typography color="grey.700" variant="label14Medium" lineHeight="">
                      All company users
                    </Typography>
                  }
                />
              </Stack>
            </RadioGroup>
          );
        }}
      />
    </Stack>
  );
};
